//src/pages/admin/TitTats.jsx
import React, { useState, useMemo } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import titService from '../../services/titService';
import { useInfiniteQuery } from '@tanstack/react-query';
import Button from '../../components/common/Button';
import TokenCarousel from '../../components/common/TitTatCarousel';
import '../../styles/TitTatCarousel.css';

const TokenFilters = ({ onFilter }) => {
  return (
    <div style={{ marginBottom: 20, gap: 10, display: 'flex' }}>
      <Button onClick={() => onFilter('ALL')}>All</Button>
      <Button onClick={() => onFilter('BID_ON')}>BID Pushed</Button>
      <Button onClick={() => onFilter('BID_OFF')}>BID NOT PUSHED</Button>
    </div>
  );
};


export default function TitTatsArtist() {
  const [filter, setFilter] = useState('ALL');

  const tokensQuery = useInfiniteQuery({
    queryKey: ['artist-tittats'],
    initialPageParam: undefined,
    queryFn: ({ pageParam }) => titService.getClientTokenizedArts({ limit: 20, cursor: pageParam }),
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.data?.pagination;
      return pagination?.has_more ? pagination?.next_cursor : undefined;
    },
  });

  const data = useMemo(() => (
    tokensQuery.data?.pages?.flatMap((page) => page?.data?.data?.items || page?.data?.data || []) || []
  ), [tokensQuery.data]);

  const filtered = useMemo(() => {
    if (filter === 'ALL') return data;
    if (filter === 'BID_ON') return data.filter((d) => d.bid_pushed);
    return data.filter((d) => !d.bid_pushed);
  }, [data, filter]);

  return (
    <DashboardLayout>
      <TokenFilters onFilter={setFilter} />
      <TokenCarousel data={filtered} />
      {tokensQuery.hasNextPage ? (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
          <Button onClick={() => tokensQuery.fetchNextPage()} disabled={tokensQuery.isFetchingNextPage}>
            {tokensQuery.isFetchingNextPage ? 'Loading...' : 'Load More'}
          </Button>
        </div>
      ) : null}
    </DashboardLayout>
  );
}